import React from 'react';
import { CSSObject, Icon } from '@chakra-ui/react';
import { Prohibited } from '@styled-icons/foundation/Prohibited';

export const betCardErrorFlexProps: CSSObject = {
  borderTopRadius: 'lg',
};

export const BetCardContainer = (): CSSObject => ({
  bg: 'epsilon.500',
  borderRadius: 'base',
  color: 'white',
  '&::before': {
    content: `""`,
    position: 'absolute',
    borderRadius: 'md',
    bgSize: '100%',
    bgRepeat: 'no-repeat',
    top: '-5',
    w: '100%',
    h: '8',
  },
});

export const IconButtonThemed: CSSObject = {
  w: 'unset',
  minW: 'unset',
  justifyContent: 'right',
  color: 'white',
  mr: '-1',
  ml: '1',
  transition: 'all .2s ease-in-out',
  _hover: {
    color: 'yellow.400',
  },
};

export const InfoBetOdds: CSSObject = {
  color: 'white',
  display: 'flex',
  fontWeight: 'extrabold',
  fontSize: 'md',
};

export const EventTitle: CSSObject = {
  fontWeight: 'medium',
  fontSize: 'sm',
  lineHeight: '4',
  flex: '1',
  textTransform: 'capitalize',
  color: 'beta.500',
};

export const EventMarketName = (isExtraInfo: boolean) => ({
  display: !isExtraInfo && 'none',
  fontSize: 'xs',
  color: 'white',
  fontWeight: 'medium',
  textTransform: 'capitalize',
});

export const EventSubtitle: CSSObject = {
  color: 'gamma.500',
  textTransform: 'capitalize',
  fontSize: 'xs',
  pt: '0.5',
};

export const ExoticsPlaceContainer: CSSObject = {
  fontWeight: 'bold',
  fontSize: 'xs',
  width: '25%',
  justifyContent: 'space-between',
};

export const TextExoticSelections: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'medium',
};

export const FlexPlacedContainer: CSSObject = {
  p: '2',
};

export const BetPlaced: CSSObject = {
  bgImage: 'linear-gradient(180deg, #FFFFFF 0%, #CBD5E0 6.25%, #FFFFFF 100%);',
  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.2), inset 0px 1px 0px #FFFFFF;',
  borderRadius: 'sm',
  flexDirection: 'column',
  color: 'black',
  px: '2',
  py: '1.5',
};

export const TextExoticsLabel: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'bold',
};

export const TextExoticsInfo: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'normal',
};

export const DefaultStakeFlexbox: CSSObject = {
  gap: '0.5',
};

export const StakeButton: CSSObject = {
  h: '9',
  bg: 'beta.600',
  color: 'black',
  borderRadius: 'md',
  border: '2px solid',
  borderColor: 'beta.400',
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.35)',
  fontWeight: 'medium',
  _hover: {
    bg: 'beta.400',
  },
  _first: {
    borderStartRadius: 'md',
  },
  _last: {
    borderStartRadius: 'md',
  },
};

export const BetPropositionClosedButton: CSSObject = {
  bg: 'beta.500',
  boxShadow: 'md',
  color: 'black',
  borderRadius: 'base',
  fontSize: 'xs',
  px: '3.5',
  h: '8',
  display: 'flex',
  gap: '1',
  _hover: {
    bg: 'beta.700',
    color: 'white',
    boxShadow: 'md',
  },
};

export const BetPlacedRow: CSSObject = {
  justifyContent: 'flex-start',
};

export const TextPlacedLabel: CSSObject = {
  flex: '1',
  color: 'gray.600',
};

export const BonusBetsButton = (isBonusBet: boolean) => ({
  bg: isBonusBet ? 'gamma.500' : 'beta.500',
  boxShadow: isBonusBet
    ? 'inset 0px 0px 5px rgba(0, 0, 0, 0.4)'
    : '0px 2px 3px rgba(0, 0, 0, 0.15), inset 0px 1px 0px rgba(255, 255, 255, 0.45)',
  color: 'black',
  borderRadius: 'base',
  border: isBonusBet ? '1px' : 'none',
  borderColor: 'gamma.300',
  fontWeight: 'medium',
  fontSize: '2xs',
  h: '6',
  px: '1.5',
  '&&': {
    minW: '20',
  },

  _hover: {
    bg: isBonusBet ? 'blackAlpha.400' : 'beta.600',
    color: 'white',
    border: isBonusBet ? '1px' : 'none',
    borderColor: 'gray.900',
    textShadow: 'none',
    boxShadow: 'none',
  },

  _active: {
    boxShadow: 'none',
  },

  _disabled: {
    boxShadow: 'none',
    border: 'none',
    bg: 'blackAlpha.300',
    color: 'beta.500',
    opacity: '1',
  },
});

export const BetPropositionClosedError: CSSObject = {
  bg: 'whiteAlpha.600',
  borderRadius: 'lg',
};

export const BetCardSVG = (header: boolean) => ({
  color: header ? 'white' : 'beta.500',
  boxSize: '6',
  display: header ? 'block' : 'none',
  mr: '0',
});

export const FlexBonusBetsWrapper = (displayBonusBetsButton: boolean) => ({
  mt: displayBonusBetsButton && '0',
});

export const IconPropositionClosed = () => (
  <Icon as={Prohibited} sx={{ boxSize: '5', '&:hover': { color: 'white' } }} />
);
